<button *ngFor="let jezyk of jezyki" class="flag-button" [title]="jezyk.etykieta" (click)="zmienJezyk(jezyk.kod)">
  <i [class]="jezyk.ikona"></i>
</button>